import { render } from "./Rain.vue?vue&type=template&id=66d8f151"
const script = {}

import "./Rain.vue?vue&type=style&index=0&id=66d8f151&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__